import z from "zod";

export const zPlanning2Settings = z.object({
  objectServiceId: z.string().uuid().nullish(),
  id: z.string().uuid().nullish(),
  taskObjectId: z.string().uuid().nullish(),
  nameAttributeId: z.string().uuid().nullish(),
  relationLinkAttributeId: z.string().uuid().nullish(),
  relationPlanDateAttributeId: z.string().uuid().nullish(),
  templateLinkAttributeId: z.string().uuid().nullish(),
  previousTaskLinkAttributeId: z.string().uuid().nullish(),
  previousTemplateTaskLinkAttributeId: z.string().uuid().nullish(),
  taskTypeAttributeId: z.string().uuid().nullish(),
  taskGroupAttributeId: z.string().uuid().nullish(),
  durationAttributeId: z.string().uuid().nullish(),
  priorityAttributeId: z.string().uuid().nullish(),
  plannedStartDateAttributeId: z.string().uuid().nullish(),
  plannedEndDateAttributeId: z.string().uuid().nullish(),
  actualStartDateAttributeId: z.string().uuid().nullish(),
  actualEndDateAttributeId: z.string().uuid().nullish(),
  departmentAttributeId: z.string().uuid().nullish(),
  employeeAttributeId: z.string().uuid().nullish(),
  planDateReversedCalculation: z.boolean().nullish(),
  forecastStartDateAttributeId: z.string().uuid().nullish(),
  forecastEndDateAttributeId: z.string().uuid().nullish(),
  delayAttributeId: z.string().uuid().nullish(),

  // Только для чтения в пользовательской части. В настройках игнорируется
  templateObjectId: z.string().uuid().nullish(),
  taskTypeTaskDictionaryValueId: z.string().uuid().nullish(),
});

export type ZPlanning2Settings = z.infer<typeof zPlanning2Settings>;
